<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row mb-4">
      <div class="col"><fcc-projetos /></div>
    </div>
    <div class="row mb-4">
      <div class="col"><fcc-projetos-nucleo-solicitante /></div>
    </div>
    <div class="row">
      <div class="col"><fcc-projetos-equipe-desenvolvimento /></div>
    </div>
  </div>
</template>
<script>
import FccProjetosEquipeDesenvolvimento from './fccProjetosEquipeDesenvolvimento.vue'
import FccProjetosNucleoSolicitante from './fccProjetosNucleoSolicitante.vue'
import FccProjetos from './fccProjetos.vue'
import '../assets/fccAcompanhamentoProjetos.scss'
import store from '@/store'

export default {
  components: {
    FccProjetos,
    FccProjetosNucleoSolicitante,
    FccProjetosEquipeDesenvolvimento
  },
  data() {
    return { titlePage: 'Andamento de Atividades' }
  },
  mounted() {
    this.carregaTexto(this.codeMensagem('C01'))

    store
      .dispatch('acompanhamentoDeProjetos/fetchAllProjetos', this.dadosLoginSession.fccTokenHeaders)
      .then(() =>
        store.dispatch(
          'acompanhamentoDeProjetos/fetchSituacoesProjeto',
          this.dadosLoginSession.fccTokenHeaders
        )
      )
      .catch(this.setErrorSystem)
      .finally(this.carregaTexto)
  }
}
</script>